export const frequencyThresholdRowColumnFlex = {
  label: 0.5,
  value: 0.9,
  context: 1,
  unit: 0.9,
} as const;

export const avgDurationThresholdRowColumnFlex = {
  label: 0.5,
  value: 0.9,
  context: 1,
  unit: 0.9,
} as const;

export const frequencyThresholdRowTemplateColumns = `${frequencyThresholdRowColumnFlex.label}fr ${frequencyThresholdRowColumnFlex.value}fr ${frequencyThresholdRowColumnFlex.context}fr ${frequencyThresholdRowColumnFlex.unit}fr`;
export const avgDurationThresholdRowTemplateColumns = `${avgDurationThresholdRowColumnFlex.label}fr ${avgDurationThresholdRowColumnFlex.value}fr ${avgDurationThresholdRowColumnFlex.unit}fr ${avgDurationThresholdRowColumnFlex.context}fr`;
